import { render, staticRenderFns } from "./TagsAutocomplete.vue?vue&type=template&id=50e4df91"
import script from "./TagsAutocomplete.vue?vue&type=script&lang=js"
export * from "./TagsAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports